module.exports = __webpack_public_path__ + "img/menuBlack.dba135f8.svg";